import { ApplyNowModal } from "@/components/common/ApplyNowModal";
import { Button } from "@/components/ui/button";
import { TrustBadges } from "@/components/common/TrustBadges";
import { Phone, MessageSquare } from "lucide-react";
import { openWhatsApp } from "@/utils/whatsapp";


export const QuickApply = () => {
  const handleWhatsAppClick = () => {
    openWhatsApp('Hi! I want to apply for a loan');
  };

  const handleCallClick = () => {
    window.open('tel:+919324471736');
  };

  return (
    <section className="py-20 px-4">
      <div className="container mx-auto max-w-4xl">
        <div className="bg-slate-800/30 backdrop-blur-lg rounded-3xl p-8 border border-slate-700">
          <h2 className="text-4xl font-bold text-center text-white mb-2">
            Get Instant Loan Approval
          </h2>
          <p className="text-center text-slate-300 mb-8">
            Fill this 30-second form and get pre-approved instantly
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-6">
            <ApplyNowModal>
              <Button
                className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 h-12 text-lg px-8"
              >
                Get Instant Approval ⚡
              </Button>
            </ApplyNowModal>

            <Button
              variant="outline"
              className="border-green-500 text-green-400 hover:bg-green-500/10 h-12 px-8"
              onClick={handleWhatsAppClick}
            >
              <MessageSquare className="h-5 w-5 mr-2" />
              WhatsApp
            </Button>

            <Button
              variant="outline"
              className="border-blue-500 text-blue-400 hover:bg-blue-500/10 h-12 px-8"
              onClick={handleCallClick}
            >
              <Phone className="h-5 w-5 mr-2" />
              Call Now
            </Button>
          </div>

          <TrustBadges />
          
          <div className="text-center mt-6 text-slate-400">
            <p>Or call us directly: <a href="tel:+919324471736" className="text-blue-400 hover:underline">+91 93244 71736</a></p>
          </div>
        </div>
      </div>
    </section>
  );
};
